import { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Modal, Row } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { ThreeDot } from "../../../assets/images";

export default function RedeemCommisionEscapeBucksProduct() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    userId: "",
    categoryId: "",
    productId: "",
    commissionType: "",
    commissionValue: "",
  });
  const [corporateUsers, setCorporateUsers] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [allCommisions, setAllCommisions] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [filters, setFilters] = useState({
    userId: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    userId: "",
  });

  useEffect(() => {
    // getAllProducts();
    getCorporateUsers();
    getProductCategories();
    getAllCommisions();
  }, []);

  useEffect(() => {
    if (formData.categoryId && formData.userId) {
      getAllProducts(formData.categoryId, formData.userId);
    } else {
      setAllProducts([]);
    }
  }, [formData.categoryId, formData.userId]);

  const getProductCategories = () => {
    axios
      .get("/escape-bucks/get-product-categories?status='true'", adminConfig())
      .then((res) => {
        if (res.data.status) {
          setProductCategories(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCorporateUsers = () => {
    axios
      .get("/get-all-corporate-tvi-users", adminConfig())
      .then((res) => {
        if (res.data.status) {
          setCorporateUsers(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getAllProducts = (categoryId, userId) => {
    setLoading(true);
    axios
      // .get("/escape-bucks/escape-bucks-products-for-admin", adminConfig())
      .get(`/escape-bucks/escape-bucks-products?userId=${userId}&categoryId=${categoryId}`, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setAllProducts(res.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getAllCommisions = () => {
    setLoading(true);
    axios
      .get("/escape-bucks/escape-bucks-product-redeem-commision", adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setAllCommisions(res.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      ...(name === "categoryId" ? { productId: "" } : {}),
      [name]: value,
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFilterSearch = (e) => {
    e.preventDefault();
    setAppliedFilters(filters);
  };

  const filteredCommisions = allCommisions.filter((item) => {
    if (!appliedFilters.userId) return true;

    const rowUserId = item?.productId?.userId?._id || item?.productId?.userId;
    return rowUserId === appliedFilters.userId;
  });

  const addNewRedeemCommision = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        "/escape-bucks/add-escape-bucks-product-redeem-commision",
        formData,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setFormData({
            userId: "",
            categoryId: "",
            productId: "",
            commissionType: "",
            commissionValue: "",
          });
          getAllCommisions();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const columns = [
    {
      name: "Client",
      selector: (row) => row?.productId?.userId?.name,
    },
    {
      name: "Name",
      selector: (row) => row?.productId?.name,
    },
    {
      name: "Price",
      selector: (row) => "$" + row?.productId?.price,
    },
    {
      name: "Commission Type",
      selector: (row) => row.commissionType,
    },
    {
      name: "Escape Credits Value",
      selector: (row) => row.commissionValue,
    },

    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                const { productId, commissionType, commissionValue, _id } = row;
                setFormData({
                  userId: productId.userId._id,
                  categoryId: productId.categoryId,
                  productId: productId._id,
                  commissionType,
                  commissionValue,
                  id: _id,
                });
                setShowEditModal(true);
              }}
            >
              Edit
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  const updateRedeemCommision = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        "/escape-bucks/update-escape-bucks-product-redeem-commision",
        formData,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          handleClose();
          getAllCommisions();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleClose = () => {
    setShowEditModal(false);
    setFormData({
      userId: "",
      categoryId: "",
      productId: "",
      commissionType: "",
      commissionValue: "",
    });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <Modal show={showEditModal} centered>
        <Modal.Header>
          <Modal.Title>Update Commision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={updateRedeemCommision}>

            <Form.Group className="mb-3">
              <Form.Label>Corporate User</Form.Label>
              <Form.Control
                as="select"
                name="userId"
                value={formData.userId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Corporate User</option>
                {corporateUsers.map((user) => (
                  <option value={user.userId} key={user.userId}>
                    {user.username || `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.name || user.email} ({user?.userEmail})
                  </option>
                ))}
              </Form.Control>
            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Product Category</Form.Label>
              <Form.Control
                as="select"
                name="categoryId"
                value={formData.categoryId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Product Category</option>
                {productCategories.map((category) => (
                  <option value={category._id} key={category._id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select Product</Form.Label>
              <Form.Control
                as="select"
                name="productId"
                value={formData.productId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Product</option>
                {allProducts.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select Commision Type</Form.Label>
              <Form.Control
                as="select"
                name="commissionType"
                value={formData.commissionType}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Value Rate</option>
                <option value="percentage"> Percentage (%) </option>
                <option value="flat"> Flat ($) </option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Escape Credits Value</Form.Label>
              <Form.Control
                type="number"
                min={0}
                placeholder="Escape Credits Value"
                required
                name="commissionValue"
                value={formData.commissionValue}
                onChange={handleOnChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="mx-3" type="submit" variant="primary">
                Update
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Add Escape Credits Value Rate Per Product</h2>
            </div>
            <Form onSubmit={addNewRedeemCommision}>
              <Row>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Corporate User</Form.Label>
                    <Form.Control
                      as="select"
                      name="userId"
                      value={formData.userId}
                      onChange={handleOnChange}
                      required
                    >
                      <option value="">Select Corporate User</option>
                      {corporateUsers.map((user) => (
                        <option value={user.userId} key={user.userId}>
                          {user.username || `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.name || user.email} ({user?.userEmail})
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Product Category</Form.Label>
                    <Form.Control
                      as="select"
                      name="categoryId"
                      value={formData.categoryId}
                      onChange={handleOnChange}
                      required
                    >
                      <option value="">Select Product Category</option>
                      {productCategories.map((category) => (
                        <option value={category._id} key={category._id}>
                          {category.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Select Product</Form.Label>
                    <Form.Control
                      as="select"
                      name="productId"
                      value={formData.productId}
                      onChange={handleOnChange}
                      disabled={!formData.categoryId}
                      required
                    >
                      <option value="">Select Product</option>
                      {allProducts.map((item) => (
                        <option value={item._id} key={item._id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Select Value Rate</Form.Label>
                    <Form.Control
                      as="select"
                      name="commissionType"
                      value={formData.commissionType}
                      onChange={handleOnChange}
                      required
                    >
                      <option value="">Select Commission Type</option>
                      <option value="percentage"> Percentage (%) </option>
                      <option value="flat"> Flat ($) </option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Escape Credits Value</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      placeholder="Escape Credits Value"
                      required
                      name="commissionValue"
                      value={formData.commissionValue}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="sub_but mt-3">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>
            <div className="cert_det_inner">
              <h2>Escape Credits Product Lists</h2>

              <Form className="mb-3">
                <Row className="align-items-end gx-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Client</Form.Label>
                      <Form.Control
                        as="select"
                        name="userId"
                        value={filters.userId}
                        onChange={handleFilterChange}
                      >
                        <option value="">All Clients</option>
                        {corporateUsers.map((user) => (
                          <option key={user.userId} value={user.userId}>
                            {user.username || `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.name || user.email} ({user?.userEmail})
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Button variant="primary" onClick={handleFilterSearch}>
                      Search
                    </Button>
                  </Col>
                </Row>
              </Form>

              <DataTable
                columns={columns}
                data={filteredCommisions}
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
              />
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
